import React, { useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import routes from '../routes'
import { SIZES } from '../styles/theme'
import { Link } from 'react-router-dom'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

import PageWithBg from '../components/PageWithBg'
import { onDemand } from '../constants/galleriumVideos'
import Amplitude from '../utils/amplitudeHelper'


const Page = styled.div`
  .full {
    position: absolute;
    padding-top: ${SIZES.navHeight};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;

    .sidenavs {
      height: 100%;
      width: 25%;
      display: flex;
      text-align: center;
      color: white;
      .page-title {
        font-weight: 600;
        width: 80%;
        font-size: 1.25em;
        align-self: center;
        padding-bottom: 60px;
      }
    }
    .main {
      width: 75%;
      /* backdrop-filter: blur(15px); */
      background-color: rgba(255, 255, 255, 0.4);
      padding: 32px 56px;
      padding-right: 72px;
      height: 100%;
      overflow-y: scroll;

      .listing {
        margin-top: 36px;

        .card-thumbnail {
          background-size: contain;
          padding: 12px;
          width: 30%;
          /* height: 200px; */
          cursor: pointer;
          position: relative;
        }
      }
      .toggle-back {
        font-weight: bold;
        color: #FFD421;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        text-decoration: none;
        .back-prev {
          display: flex;
          width: 30px;
          flex-direction: column;
          img, svg {
            transition: 100ms linear;
            height: 24px;
          }
          .icon-label {
            transition: 100ms linear;
            text-align: left;
            font-size: 1px;
            opacity: 0;
          }
          &:hover {
            img, svg {
              transform: scale(0.5);
            }
            .icon-label {
              font-size: 8px;
              opacity: 1;
            }
          }
        }
        span {
          font-size: 24px;
          font-style: italic;
          margin-left: 1em;
          color: #FFB831;
        }
      }
    }
  }
`

export default function PosterGalleryPage({ currentUser }) {

  useEffect(() => {
    document.title = `${config.eventName} | On-Demand`
  }, [])

  useEffect(() => {
    Amplitude.visit(`On-Demand`)
  }, [currentUser.id])
 
  return (
    <Page>
      <PageWithBg bgImg={config.assets.gallerium}>
        <section className="full">
          <div className="sidenavs">
            <span className="page-title">On-Demand</span>
          </div>
          <div className="main">
            <Link to={routes.lobby} className="toggle-back">
              <div className="back-prev">
                <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839">
                  <g transform="translate(17.301 26.839) rotate(180)">
                    <path d="M.459,14.462,13.147,26.407a1.637,1.637,0,0,0,2.216,0l1.48-1.393a1.415,1.415,0,0,0,0-2.084L6.79,13.419,16.845,3.909a1.415,1.415,0,0,0,0-2.084L15.363.432a1.637,1.637,0,0,0-2.216,0L.459,12.376A1.415,1.415,0,0,0,.459,14.462Z" transform="translate(17.301 26.839) rotate(180)" fill="#ffd421"/>
                  </g>
                </svg>
                <small className="icon-label">Back</small>
              </div>
              <span>On-Demand</span>
            </Link>

            <div className="d-flex align-items-center h-75 listing">
              {
                onDemand.map(item=>(
                  <LazyLoadComponent key={item.name}>
                    <Link
                      to={item.destination}
                      className="card-thumbnail"
                    >
                      <img src={item.thumbnail} width="100%" alt="thumbnail" />
                    </Link>
                  </LazyLoadComponent>
                ))
              }
            </div>

          </div>
        </section>
      </PageWithBg>
    </Page>
  )
}
